import { Link } from "react-router-dom";

export default function CheckoutCancel() {
  return (
    <div className="pt-28 md:pt-40 min-h-screen max-w-[1440px] mx-auto px-6 md:px-10 pb-24" data-testid="checkout-cancel">
      <p className="font-mono text-[10px] uppercase tracking-editorial text-[#1A1714]/60">Ch. 09 — Paused</p>
      <h1 className="font-serif text-6xl md:text-8xl tracking-tight leading-none mt-3">
        Not yet — <em className="font-light">that's fine.</em>
      </h1>
      <p className="font-serif text-xl mt-8 text-[#1A1714]/70 max-w-md">
        Your basket is still here. Take your time.
      </p>
      <Link to="/shop" className="mt-10 inline-block border border-[#1A1714] px-6 py-3 font-mono text-[11px] uppercase tracking-editorial hover:bg-[#1A1714] hover:text-[#F9F6F0] transition-colors" data-testid="cancel-back">
        Back to the shelf →
      </Link>
    </div>
  );
}
